export default function PricingComparison() {
  const features = [
    { category: "Core Features", items: [
      { name: "Flight scoring", free: "Basic", pro: "Advanced", instructor: "Advanced" },
      { name: "Monthly flight limit", free: "5 flights", pro: "Unlimited", instructor: "Unlimited" },
      { name: "Radio transcription", free: true, pro: true, instructor: true },
      { name: "Flight replay viewer", free: true, pro: true, instructor: true },
    ]},
    { category: "Analysis & Insights", items: [
      { name: "Pattern analysis", free: false, pro: true, instructor: true },
      { name: "AI coaching insights", free: false, pro: true, instructor: true },
      { name: "Progress tracking", free: false, pro: true, instructor: true },
      { name: "Performance reports", free: false, pro: false, instructor: true },
    ]},
    { category: "Community & Collaboration", items: [
      { name: "Community replays", free: false, pro: true, instructor: true },
      { name: "Student management", free: false, pro: false, instructor: true },
      { name: "Multi-student tracking", free: false, pro: false, instructor: true },
      { name: "Custom lesson plans", free: false, pro: false, instructor: true },
    ]},
    { category: "Support & Customization", items: [
      { name: "Email support", free: true, pro: true, instructor: true },
      { name: "Priority support", free: false, pro: false, instructor: true },
      { name: "White-label branding", free: false, pro: false, instructor: true },
      { name: "API access", free: false, pro: false, instructor: true },
    ]},
  ];

  const renderCell = (value: boolean | string) => {
    if (typeof value === "boolean") {
      return value ? (
        <i className="ri-checkbox-circle-fill text-[#00FFD1] text-xl"></i>
      ) : (
        <i className="ri-close-circle-line text-gray-600 text-xl"></i>
      );
    }
    return <span className="text-sm font-medium text-gray-300">{value}</span>;
  };

  return (
    <section className="relative py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Feature comparison</h2>
          <p className="text-lg text-gray-400">See exactly what's included in each plan</p>
        </div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="text-left py-6 px-8 text-sm font-semibold text-gray-400 uppercase tracking-wider">
                    Feature
                  </th>
                  <th className="text-center py-6 px-8 text-sm font-bold uppercase tracking-wider">
                    Free
                  </th>
                  <th className="text-center py-6 px-8 text-sm font-bold uppercase tracking-wider bg-[#00FFD1]/5">
                    Pro
                  </th>
                  <th className="text-center py-6 px-8 text-sm font-bold uppercase tracking-wider">
                    Instructor
                  </th>
                </tr>
              </thead>
              <tbody>
                {features.map((section, sectionIdx) => (
                  <>
                    <tr key={`category-${sectionIdx}`} className="border-t border-white/10">
                      <td colSpan={4} className="py-4 px-8 bg-white/5">
                        <span className="text-xs font-bold text-[#00FFD1] uppercase tracking-widest">
                          {section.category}
                        </span>
                      </td>
                    </tr>
                    {section.items.map((item, itemIdx) => (
                      <tr
                        key={`item-${sectionIdx}-${itemIdx}`}
                        className="border-b border-white/5 hover:bg-white/5 transition-colors"
                      >
                        <td className="py-5 px-8 text-sm text-gray-300">{item.name}</td>
                        <td className="py-5 px-8 text-center">{renderCell(item.free)}</td>
                        <td className="py-5 px-8 text-center bg-[#00FFD1]/5">{renderCell(item.pro)}</td>
                        <td className="py-5 px-8 text-center">{renderCell(item.instructor)}</td>
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}